import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import themeObject from 'src/styles/theme';
import WCThemeObject from 'src/styles/theme/wc_theme';
import GlobalStyles from 'src/styles/GlobalStyles';
import { useLocation } from 'react-router-dom';

export const themeContext = React.createContext({
  themeType: '',
  theme: themeObject,
  toggleTheme: () => {},
  isWalletCodePage: false,
});

const ThemeProvider = ({ children }) => {
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [isWalletCodePage, setIsWalletCodePage] = useState(location.pathname.indexOf('wallet_codes') > -1);
  const [theme, setTheme] = useState(isWalletCodePage ? WCThemeObject : themeObject);
  const {
    palette: { type: themeType }
  } = theme;
  const themeConfig = createMuiTheme(theme);

  useEffect(() => {
  //   if (!isWalletCodePage) {
  //   //   setIsWalletCodePage(location.pathname.indexOf('wallet_codes') > -1);
  //     setTheme(isWalletCodePage ? WCThemeObject : themeObject);
  //   }
    const isWCPage = location.pathname.indexOf('wallet_codes') > -1;
    if (isWalletCodePage !== isWCPage) {
      setIsWalletCodePage(!isWalletCodePage);
      setTheme(isWCPage ? WCThemeObject : themeObject);
    }
  }, [location]);

  // https://v4.mui.com/customization/palette/#dark-mode
  const toggleTheme = () => {
    const updatedTheme = isWalletCodePage ? {
      ...theme,
      palette: {
        ...theme.palette,
        type: (themeType === 'light' ? 'dark' : 'light'),
        background: {
          dark: (themeType === 'light' ? '#13192F' : '#E1F7FE'),
          paper: (themeType === 'light' ? '#1E2742' : '#EFFBFF'),
          default: (themeType === 'light' ? '#0F172A' : '#fff'),
        },
        text: {
          primary: themeType === 'light' ? '#fff' : '#222222',
          secondary: themeType === 'light' ? 'rgba(255, 255, 255, 0.7)' : '#545454'
        },
      }
    } : {
      ...theme,
      palette: {
        ...theme.palette,
        type: (themeType === 'light' ? 'dark' : 'light'),
        background: {
          dark: (themeType === 'light' ? '#022430' : '#f4f6f8'),
          paper: (themeType === 'light' ? '#0F172A' : '#fff'),
          default: (themeType === 'light' ? '#1E293B' : '#fff'),
        },
        text: {
          primary: themeType === 'light' ? '#fff' : '#222222',
          secondary: themeType === 'light' ? 'rgba(255, 255, 255, 0.7)' : '#545454'
        },
      }
    };

    setTheme(updatedTheme);
  };

  return (
    <themeContext.Provider
      value={{
        themeType,
        theme,
        toggleTheme,
        isWalletCodePage
      }}
    >
      <MuiThemeProvider theme={themeConfig}>
        <GlobalStyles />
        {children || <div />}
      </MuiThemeProvider>
    </themeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default ThemeProvider;
